import type { AvailabilitySegment, OverrideRequestStatus } from "./segments";

export interface ItemUser {
    id: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
    employeeNumber?: string;
    image?: string;
}

export interface SegmentActionTarget {
    user: ItemUser;
    label: string;
    dayKey: string;
    segment: AvailabilitySegment;
    defaultDate?: string;
}

export interface SegmentOverride {
    status: OverrideRequestStatus;
    to?: string;
}

export const getSegmentKey = (dayKey: string, segment: AvailabilitySegment): string =>
    `${dayKey}-${segment.from ?? ""}-${segment.to ?? ""}`;
